import { SalesforceFrontendAddressResolver } from '@v2/services/resolvers/salesforce-frontend-address-resolver';
import { AddressResolver, AddressResolverFactory } from 'shared/execution/types';
import { diContainer } from 'shared/infrastructure/di-container';
import { HubspotAddressResolver } from 'shared/providers/hubspot/hubspot-address-resolver';
import { Flowstep, ProviderType } from 'shared/types/flowstep';

export class FrontendAddressResolverFactory implements AddressResolverFactory {
  getAddressResolver(flowstep: Flowstep, context: any): AddressResolver {
    if (flowstep.provider === ProviderType.HS || flowstep.provider === ProviderType.HubspotList) {
      const workbookApi = diContainer.cradle.workbookApiFactory(context);
      return new HubspotAddressResolver(workbookApi);
    }
    if (
      flowstep.provider === ProviderType.SalesforceReport ||
      flowstep.provider === ProviderType.SalesforceSoql
    ) {
      return new SalesforceFrontendAddressResolver();
    }
    throw new Error(`No address resolver found for provider ${flowstep.provider}`);
  }
}
